// components/ButtonSubmit.jsx
import { Button, CircularProgress } from '@mui/material';
import React from 'react';

function ButtonSubmit({
  name = "",
  icon: Icon,
  loading,
  color = 'success',
  onClick,
  type = 'submit',
  disabled = false,       // nuevo (opcional)
  fullWidth = false,      // nuevo (opcional) - default false para no romper layouts
  sx                      // nuevo (opcional)
}) {
  return (
    <Button
      type={type}
      variant="contained"
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : (Icon ? <Icon /> : null)}
      color={color}
      disabled={loading || disabled}
      onClick={onClick}
      fullWidth={fullWidth}
      sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 800, ...sx }}
    >
      {loading ? "Enviando..." : name}
    </Button>
  );
}

export default ButtonSubmit;
